<template>
  <div class="main" id="main">
    <van-popup class='showPopup' v-model:show="state.show"  position="right">
      <div class="matchInfo">
        <div class="popMatchName">{{state.matchInfo.matchName}}</div>
        <div class="popMatchTime">{{state.matchInfo.startDate}}</div>
        <div class="popMatchTime">{{state.projectInfo.groupName}}</div>
      </div>
      <!-- 侧滑弹窗 -->
      <div class="matchName" v-for="(data, idx) in state.propshowData" :key="idx" @click="goProjectFun(data)" >
        <div class="propBox " :class="{'thisShow':data.topic==state.projectTopic}" >
          <div  class="matchTypeName" >{{data.matchType}}-{{data.groupNo}}组</div>
          <!-- <van-icon name="arrow" /> -->
        </div>
      </div>
    </van-popup>
    <div class="RankheaderBox" >
      <van-nav-bar class="title" :title="state.matchInfo.matchName">
        <template #right >
          <van-icon name="wap-nav" size="18"  color="#fff" @click="showPopup()"/>
        </template>
        <template #left >
          <van-icon name="arrow-left" size="18"  color="#fff" @click="backFun()"/>
        </template>
      </van-nav-bar>
      <div class="projectBox">{{state.projectInfo.matchProjectName}}-{{state.projectInfo.projectTypeName}}</div>
    </div>
    <div class="RankmatchList" v-if="state.svgComponentName!=''">
      <router-view :svgName="state.svgComponentName" :showData="showList" ></router-view>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, toRefs,onMounted } from "vue";
import Paho from "../../common/js/mqtt.js";
import { useRouter } from "vue-router";
import { createState } from "../../store";
var opt;
export default {
  components: {  },
  setup() {
    const router = useRouter();
    const data = reactive(createState);
    data.projectTopic = router.currentRoute.value.query.projectTopic
    const dataRef = toRefs(data);
    const projectList = data.projectList
    const groupList = data.groupList
    console.log(data)
    function goFun(url, topicData) {
      router.push({
        path: url,
        query: topicData
      });
    }
    return {
      state: reactive(createState),
      Paho: Paho,
      goFun,
      client: ref({}),
      projectList: ref([]),
      title: ref(''),
      showList:ref(data.showList),
      matchName:ref(''),
      projectList,
      groupList,
    };
  },
  methods: {
    showPopup () {
      this.state.show = true;
    },
    goProjectFun(data){
      // 只需要修改 state.projectTopic，watch 会自动处理轮询
      console.info("切换项目 topic：" + data.topic);
      this.state.projectTopic = data.topic;
      this.state.topicType = true;
    },
    backFun(){
      console.log('返回项目列表，清空 projectTopic');
      // 清空 projectTopic，watch 会自动停止轮询
      this.state.projectTopic = '';
      
      const topicData = {
        selectedMatchId:this.state.selectedMatchId,
      };
      this.$router.push({
        path: "/project",
        query: topicData
      });
    }
  },
  mounted() {
    // 如果有 projectTopic，会自动通过 watch 启动轮询
    console.log('Ranking 页面加载，当前 projectTopic:', this.state.projectTopic);
  },
  // 组件卸载前清空 projectTopic
  beforeUnmount() {
    console.log('Ranking 页面卸载，清空 projectTopic');
    this.state.projectTopic = '';
  },
};
</script>

<style lang="less" scoped>
.popMatchName{
  width: 100%;
  height: 0.8rem;
  text-align: center;
  font-size: 0.4rem;
  background: #39a9ed;
  line-height: 0.8rem;
  color: #fff;
  overflow: hidden;
}
.popMatchTime{
  width: 100%;
  height: 0.8rem;
  text-align: center;
  font-size: 0.4rem;
  margin-top: 0.2rem;
  border-bottom: 1px solid #aaa;
  overflow: hidden;
}
.thisShow{
  background: #eee;
}
/deep/.showPopup{
  width: 70%;
  height: 100%;
  background: #fff;
  .propBox{
    width: 100%;
    height: 1rem;
    border-bottom: 1px solid #eee;
    line-height: 1rem;
    .matchTypeName{
      width: 90%;
      float: left;
      text-indent: 6px;
      font-size: 0.36rem;
      font-weight: 700;
    }
  }
}
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.RankheaderBox {
  width: 100%;
  height: 1.8rem;
  position: fixed;
    background: #fff;
    z-index: 10;
    .projectBox{
      height: 0.8rem;
      line-height: 0.8rem;
      font-weight: 700;
      text-align: center;
      font-size: 0.4rem;
    }
  .title{
    background: #39a9ed;
    height: 1rem;
    width: 100%;
    display: block;
    /deep/.van-ellipsis{
      color: #fff;
      max-width: 80%;
      font-size: 0.4rem;
      height: 100%;
      line-height: 1rem
    }
    /deep/.van-nav-bar__content{
      height: 100%;
    }
  }
  
}
.ranking{
display: block;
  width: 13%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.name{
display: block;
  width: 15%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.org{
display: block;
  width: 50%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.totalScore{
display: block;
  width: 20%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.QF{
  background-color: red;
  color: #fff;
}
.RankmatchList {
  margin-top: 1.8rem;
  flex: 1;
  height: auto;
  width: 100%;
  background: #fff;
  .listTit{
    width: 100%;
    height: 0.8rem;
    margin: 0 2%;
    background: #fff;
    text-align: center;
    font-size: 0.4rem;
    font-weight: 700;
    border-bottom: 1px solid #ccc;
  }
  .van-list {
    width: 100%;
    height: 100%;
    .matchName {
      font-weight: 700;
      width: 100%;
      height: 1rem;
      text-align: left;
      line-height: 1rem;
      font-size: 0.3rem;
      text-align: center;
      .borderBox {
        width: 96%;
        height: 1rem;
        margin: 0 2%;
        overflow: hidden;
        // border-bottom: 1px solid #333;
      }
      // span {
      //   width: 96%;
      //   height: 1rem;
      //   box-sizing: border-box;
      //   display: inline-block;
      //   word-break: keep-all; /* 不换行 */
      //   white-space: nowrap; /* 不换行 */
      //   overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
      //   text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
      //   float: left;
      // }
      .icon {
        width: 0.2rem;
        height: 1rem;
        line-height: 1rem;
        float: left;
      }
    }
  }
}
</style>